import { FaFacebookF } from 'react-icons/fa'

const FaceBook = () => {
   return (
      <>
         <a href="https://www.facebook.com/latitudsur.arg" target="_blank" className="facebook-float pulse" title="FaceBook">
            <FaFacebookF/>
         </a>
      </>
   )
}

export default FaceBook;